import React from 'react';
import PropTypes from 'prop-types';
import renderHTML from 'react-render-html';
import * as features from '../../../data/featureUpselling';
import { uppercaseUnderscore } from '../../../utils/stringConversion';
import ModalContainer from './ModalContainer';
import ModalBody from './ModalBody';
import ModalPadding from './ModalPadding';
import CloseButton from '../Buttons/CloseButton';

const UpsellModal = ({ loggedInUser, modalIsOpen, onCloseClick, upsellFeature }) => {
  const upsellFeatureFormatted = uppercaseUnderscore(upsellFeature);
  const { title, summary, minAccess, imageSrc } = features[upsellFeatureFormatted];

  const cta = { text: '', link: '' };
  // If the user isn't logged in then text and link need to change
  if (loggedInUser.notLoggedIn) {
    cta.text = 'Sign up for free';
    cta.link = `/signup?plan_type=${minAccess}`;
  } else {
    cta.text = 'Upgrade today';
    cta.link = '/account/plan';
  }

  return (
    <ModalContainer
      isOpen={modalIsOpen}
      closeModal={onCloseClick}
      label="Upgrade modal"
      size="l"
      classes="modal-inner--upsell text-center"
    >
      <ModalBody>
        <ModalPadding>
          {imageSrc &&
            <img src={imageSrc} alt="" className="modal-image" />
          }

          <h1 className="modal-title fw-bold">{title}</h1>
          <p className="modal-summary h3 text-grey">{renderHTML(summary)}</p>
          <a href={cta.link} className="btn btn-L">{cta.text}</a>

          <CloseButton onClick={onCloseClick} />
        </ModalPadding>
      </ModalBody>
    </ModalContainer>
  );
};

UpsellModal.propTypes = {
  loggedInUser: PropTypes.object.isRequired,
  modalIsOpen: PropTypes.bool.isRequired,
  onCloseClick: PropTypes.func.isRequired,
  upsellFeature: PropTypes.string.isRequired,
};

export default UpsellModal;



// WEBPACK FOOTER //
// ./library/app/components/Global/Modals/UpsellModal.js